import React, { useState } from 'react';
import ModalDialog from '../components/Dialog/ModalDialog';
import Typography from '../components/Text/Typography';
import './ContactUsDialog.css';

interface ContactUsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSend?: (message: string) => void;
}

const ContactUsDialog: React.FC<ContactUsDialogProps> = ({ isOpen, onClose, onSend }) => {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (message.trim()) {
      // Create mailto link with pre-filled email
      const subject = encodeURIComponent('User feedback/comment');
      const body = encodeURIComponent(message);
      const mailtoLink = `mailto:dew.don.lee@gmail.com?subject=${subject}&body=${body}`;
      
      // Open default email client
      window.open(mailtoLink, '_blank');
      
      // Call the onSend callback if provided
      if (onSend) onSend(message);
      
      // Clear the message and close dialog
      setMessage('');
      onClose();
    }
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Contact Us"
      primaryButton={{
        label: "Send",
        onClick: handleSend,
        disabled: !message.trim()
      }}
      secondaryButton={{
        label: "Cancel",
        onClick: onClose
      }}
      maxWidth="500px"
    >
      <div className="contact-us-dialog">
        <textarea
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="Write message"
          className="contact-us-dialog__textarea"
        />
        
        <Typography variant="body" className="contact-us-dialog__helper-text">
          Clicking "Send" will open your default email client with a pre-filled message.
        </Typography>
      </div>
    </ModalDialog>
  );
};

export default ContactUsDialog;
